import { AsyncSelect, type IAsyncSelectProps } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { requestableCategoryRepository } from '@webapp/modules/expense/data-access/repositories/RequestableCategoryRepository'
import messages from './messages'

export type RequestablePrimaryCategorySelectValue = {
  id: number
  name: string
}

export interface IRequestablePrimaryCategorySelectProps extends IAsyncSelectProps<RequestablePrimaryCategorySelectValue> {}

export const RequestablePrimaryCategorySelect = ({
  ...props
}: IRequestablePrimaryCategorySelectProps) => {
  const intl = useProcurifyIntl()

  const loadOptions: IRequestablePrimaryCategorySelectProps['loadOptions'] =
    async (_inputValue, _pagination, callback) => {
      try {
        const locations =
          await requestableCategoryRepository.listRequestableLocations()
        callback({
          options: locations.map((location) => ({
            id: location.id,
            name: location.name,
          })),
          pagination: {
            hasMore: false,
            page: 1,
          },
        })
      } catch {
        callback({
          options: [],
          pagination: { hasMore: false, page: 1 },
        })
      }
    }

  return (
    <AsyncSelect<RequestablePrimaryCategorySelectValue>
      cacheOptions={true}
      defaultOptions={true}
      loadOptions={loadOptions}
      placeholder={intl.formatMessage(messages.placeholderText)}
      getOptionLabel={(option) => option.name}
      getOptionValue={(option) => option.id.toString()}
      {...props}
    />
  )
}
